import { useEffect } from "preact/hooks";

/**
 * @param disableDebounce If true, quantity normalization will happen immediately without debounce
 * @param normalize Returns the allowed quantity for a typed one (minimum order quantity, order increment)
 * @param quantity The current quantity value to be normalized
 * @param setQuantity Function to update the quantity state in the parent component
 * @param onQuantityChange Optional callback to notify parent component of quantity changes
*/
export function useQuantityNormalization(
    disableDebounce: boolean = false,
    normalize: (quantity: number) => number,
    quantity: number,
    setQuantity: (value: number) => void,
    onQuantityChange?: (value: number) => void
) {
    useEffect(() => {
        if (disableDebounce) {
            const normalizedQuantity = normalize(quantity);

            setQuantity(normalizedQuantity);
            onQuantityChange?.(normalizedQuantity);
            return;
        }

        const timer = setTimeout(() => {
            const normalizedQuantity = normalize(quantity);

            setQuantity(normalizedQuantity);
            onQuantityChange?.(normalizedQuantity);
        }, 1000); // 1000ms debounce

        return () => clearTimeout(timer);
    }, [quantity, setQuantity]);
}
